import * as React from "react";

import "./new-code-messages.scss";

import {cs}            from "@Common/react/chain-services";
import {fragments}     from "@Common/react/fragments";
import {keyed}         from "@Common/react/keyed";
import {TimeoutAction} from "@Common/react/timeout-action";
import {UseState}      from "@Common/react/use-state";
import {formatMoneyUS}  from "@Common/ui-components/language/format-money";
import {randomId}      from "@Common/utils/random";

export const NewCodeMessages = ({next}) => cs(
    ["newCodes", (_, next) => UseState({next})],
    ({newCodes}) => fragments(
        next({
            clear: () => newCodes.onChange(null),
            setCodes: (newCodes1) => newCodes.onChange(newCodes1?.map((code) => ({
                key: randomId(),
                code,
            }))),
            render: () => (
                <div className="new-code-messages new-code-messages-9jb">
                    {newCodes.value?.map(({key, code}) => cs(
                        keyed(key),
                        ({}, next) => fragments(
                            next(),
                            TimeoutAction({
                                delay: 50000,
                                action: () => newCodes.change((_) => _.filter((e) => e.key !== key)),
                            }),
                        ),
                        () => (
                            <div className="message">
                                Promocode {code.code} has been applied to order{" "}
                                {code.itemId} - {formatMoneyUS(code.amount)}
                            </div>
                        )
                    ))}
                </div>
            ),
        }),
    ),
);
